import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { ITestimonialSlide, ITestimonialCarousel } from './types'
import Carousel from '../Carousel'

// MUI

import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { grey } from '@mui/material/colors'

// TDC Theme
import { boxShadow } from '@tdcerhverv/mui-theme/dist/theme/global/shadows'

const Testimonial = ({ title, slides }: ITestimonialCarousel) => {
  const numberOfSlides = slides?.length

  const styles = {
    slide: {
      listStyle: 'none',
      display: 'block',
    },
    singleSlide: {
      margin: `0 auto`,
      maxWidth: '750px',
      padding: '40px',
      borderLeft: `1px solid ${grey[400]}`,

      '& $clientQuote': {
        textAlign: 'left',
        fontSize: '16px',
      },
      '& $clientInformation': {
        justifyContent: `flex-start`,
      },
      '& $profileImage': {
        maxHeight: '40px',
      },
    },
    profileImage: {
      maxHeight: '40px',
      marginRight: '16px',
    },
    clientInformation: {
      marginTop: '36px',
      display: `flex`,
      alignItems: `center`,
      justifyContent: `center`,
    },
    testimonialCard: {
      boxShadow: boxShadow.medium,

      '& .MuiCardContent-root': {
        padding: '40px',
      },
    },
    clientQuote: {
      typography: 'h5',
      fontStyle: 'italic',
      fontWeight: 400,
      textAlign: 'center',
    },
    clientDetails: {
      display: `flex`,
      justifyContent: `center`,
      alignItems: `flex-start`,
      flexDirection: `column`,
    },
  }

  if (numberOfSlides < 2) {
    const singleSlide: ITestimonialSlide = slides[0]
    return (
      <Box sx={styles.singleSlide}>
        <Typography
          sx={styles.clientQuote}
        >{`“${singleSlide.clientQuote.clientQuote}”`}</Typography>
        <Box sx={styles.clientInformation}>
          {singleSlide.clientImage && (
            <GatsbyImage
              style={styles.profileImage}
              image={singleSlide.clientImage.gatsbyImageData}
              alt={`${title} profile image`}
            />
          )}
          <Box sx={styles.clientDetails}>
            <Typography variant="subtitle2">
              {singleSlide.clientName}
            </Typography>
            <Typography variant="caption">
              {singleSlide.clientDetails}
            </Typography>
          </Box>
        </Box>
      </Box>
    )
  }

  return (
    <Carousel
      title={title}
      controlPosition="SPACED"
      numberOfSlidesInView={1}
      overflow={true}
    >
      {slides &&
        slides.map((slide: ITestimonialSlide, index) => (
          <Box component="li" key={index} sx={styles.slide}>
            <Card sx={styles.testimonialCard}>
              <CardContent>
                <Typography sx={styles.clientQuote}>
                  {`“${slide.clientQuote.clientQuote}”`}
                </Typography>
              </CardContent>
            </Card>
            <Box sx={styles.clientInformation}>
              {slide.clientImage && (
                <GatsbyImage
                  style={styles.profileImage}
                  image={slide.clientImage.gatsbyImageData}
                  alt={`${title} profile image`}
                />
              )}
              <Box sx={styles.clientDetails}>
                <Typography variant="subtitle2">{slide.clientName}</Typography>
                <Typography variant="caption">{slide.clientDetails}</Typography>
              </Box>
            </Box>
          </Box>
        ))}
    </Carousel>
  )
}

export default Testimonial
